import React, { FC } from "react";
import { ApiErrorResponse, Status } from "types";
import LoadingSpinner from "./LoadingSpinner";
import { formatMessage } from "i18n/CurrentLocale";


export type ActionStatusProps = {
    status: Status,
    succeededMessage: any,
    errorMessage: any
}

export const ActionStatusDisplayer: FC<ActionStatusProps> = (props) => {

    const { status, succeededMessage, errorMessage } = props;

    if (status.loading) {
        return <LoadingSpinner />
    }
    if (status.succeeded) {
        return succeededMessage;
    }
    if (status.error) {
        return getErrorMessage(status.error, errorMessage);
    }
}


export const getErrorMessage = (error: ApiErrorResponse, fallbackErrorMessage: string) => {
    const errorKey = error?.response?.body?.data?.errorKey;

    if (error.status === 400 && errorKey === 'FLEET_MANAGER_SELF_DELETION_FORBIDDEN') {
        return formatMessage({ id: 'API_ERROR_FLEET_MANAGER_SELF_DELETION_FORBIDDEN' });
    }
    else if (error.status === 400 && errorKey === 'EMAIL_ID_EXISTS') {
        return formatMessage({ id: 'API_ERROR_EMAIL_ID_EXISTS' });
    }
    else {
        return fallbackErrorMessage;
    }
}
